import {
  createViewerCapabilities,
  type ViewerCapabilities,
} from '@ironview/interactive-viewer';

import {
  createIronview360ViewerContext,
  ironview360ViewerAdapter,
} from './adapters/ironview360DataAdapter';
import { ironview360ViewerExtensionRegistry } from './extensions/ironview360Extensions';

/**
 * The single Ironview 360 host boundary consumed by the shared viewer.
 *
 * Construction hotspot objects and the issue heat map are registered as
 * Ironview 360 extensions. Guided tours, AreaTag export/copy, and background
 * uploads remain host workflows outside the base package. Legacy sharing and
 * overlay-group APIs are intentionally not represented here.
 */
export const ironview360ViewerCapabilities: ViewerCapabilities =
  createViewerCapabilities({
    layouts: {
      manage: true,
      uploadImage: true,
      uploadPdf: true,
      reusePdfAsset: true,
      copyPdfConfiguration: true,
      detachPdf: true,
    },
    markers: {
      edit: true,
      resequence: true,
    },
    areaTags: {
      create: true,
      edit: true,
      delete: true,
    },
    hotspots: {
      create: true,
      edit: true,
      delete: true,
    },
  });

export const ironview360InteractiveViewerIntegration = {
  adapter: ironview360ViewerAdapter,
  capabilities: ironview360ViewerCapabilities,
  createContext: createIronview360ViewerContext,
  extensions: ironview360ViewerExtensionRegistry,
} as const;
